import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import { Box, IconButton, Typography, Grid, Avatar, Menu, MenuItem } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { HeaderBox, FixedBottomBar } from './mBookListPage';
import HomeServices from '../../Services/Home'; 
import withLyric from '../../Images/Image/withLyrics.png'
import withoutLyric from '../../Images/Image/withoutLyrics.png';
import defaultImg from '../../Images/defaultBook.png';
const MobileRecentlyViewed = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
 const [recentViews, setRecentViews] = React.useState([]);
 const [menuAnchorEl, setMenuAnchorEl] = React.useState<null | HTMLElement>(null);
 const menuOpen = Boolean(menuAnchorEl);

 const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
   setMenuAnchorEl(event.currentTarget);
 };
 const handleMenuClose = () => {
   setMenuAnchorEl(null);
 };
  useEffect(() => {     
    const fetchRecentViews = async () => {
      try {
        const lang = localStorage.getItem('lang') || 'en'; 
        const length = 10; 
        const response = await HomeServices.getRecentViews(lang, length);
        console.log('Recent Views:', response);
        if (response && response.status) {
          setRecentViews(response.result.items || []);
        } else {
          console.error('Failed to fetch recent views:', response);
        }
      } catch (error) {
        console.error('Error fetching recent views:', error);
      }
    };

    fetchRecentViews();
  }, []);

  // Handler for delete menu actions
  const handleDeleteRecent = async (recentParam: number) => {
    try {
      await HomeServices.deleteRecentView(recentParam);
      // Refetch recent views after deletion
      const lang = localStorage.getItem('lang') || 'en';
      const length = 10;
      const response = await HomeServices.getRecentViews(lang, length);
      if (response && response.status) {
        setRecentViews(response.result.items || []);
      }
    } catch (error) {
      console.error('Error deleting recent views:', error);
    } finally {
      handleMenuClose();
    }
  };

  return (
    <Box sx={{ bgcolor: 'whitesmoke', minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      {/* Header */}
      <HeaderBox>
        <IconButton onClick={() => navigate(-1)} sx={{ position: 'absolute', left: 16, top: 35, p: 0 }}>
          <ArrowBackIosIcon sx={{ color: 'white', fontSize: '18px' }} />
        </IconButton>
        <IconButton onClick={() => navigate("/")} sx={{ position: 'absolute', left: 48, top: 35, p: 0 }}>
          <HomeOutlinedIcon sx={{ color: 'white', fontSize: '24px' }} />
        </IconButton>
        {/* Delete icon at top right */}
        <IconButton onClick={handleMenuOpen} sx={{ position: 'absolute', right: 16, top: 35, p: 0 }}>
          <DeleteIcon sx={{ color: 'white', fontSize: '20px' }} />
        </IconButton>
        {/* Delete menu */}
        <Menu
          anchorEl={menuAnchorEl}
          open={menuOpen}
          onClose={handleMenuClose}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
          <MenuItem onClick={() => handleDeleteRecent(0)}>समस्त</MenuItem>
          <MenuItem onClick={() => handleDeleteRecent(1)}>आज</MenuItem>
          <MenuItem onClick={() => handleDeleteRecent(2)}>सप्ताह</MenuItem>
          <MenuItem onClick={() => handleDeleteRecent(3)}>महीना</MenuItem>
        </Menu>
        <Typography variant="caption" sx={{ color: '#ffffffdd', opacity: 0.9, mb: 0.5 }}>
          {t('shrihari_tr')}
        </Typography>
        <Typography variant="h6" sx={{ color: '#ffffffdd', opacity: 0.9, fontSize: 15 }}>
          {t('Recent_Seen')}
        </Typography>

      </HeaderBox>
      {/* Total records below header */}
      <Box sx={{ width: '100%', textAlign: 'center', bgcolor: 'whitesmoke', py: 0.5 }}>
        <Typography variant="caption" sx={{ color: '#333', fontWeight: 500, fontSize: 12 }}>
          {t('Total_Records_tr') || 'Total records'}: {recentViews.length}
        </Typography>
      </Box>

      {/* Main Content */}

      <Box sx={{ flexGrow: 1, p: 0.5 }}>
        {recentViews.length > 0 ? (
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '2%', justifyContent: 'flex-start', mt: 1 }}>
            {recentViews.map((item: any, index: number) => {
              let img = null;
              let title = '';
              let subtitle = '';
              let typeLabel = '';
              let icon = null;
              // Choose icon or image based on type
              // Universal lyrics icon logic for all types
              let lyricsHash = null;
              if (item.type === 'audios' && item.audios) {
                img = item.audios.thumbPath || item.audios.coverImage || item.audios.image || null;
                title = item.audios.name;
                subtitle = item.audios.engName || '';
                typeLabel = t('Audio_tr') || 'Audio';
                lyricsHash = item.audios.lyricsHash;
              } else if (item.type === 'pravachans' && item.pravachans) {
                img = item.pravachans.thumbPath || item.pravachans.coverImage || item.pravachans.image || null;
                title = item.pravachans.name;
                subtitle = item.pravachans.engName || '';
                typeLabel = t('pravachan_tr') || 'Pravachan';
                lyricsHash = item.pravachans.lyricsHash;
              } else if (item.type === 'books' && item.books) {
                img = item.books.thumbPath || item.books.coverImage || item.books.image || null;
                title = item.books.name;
                subtitle = item.books.engName || '';
                typeLabel = t('E_books_tr');
                lyricsHash = item.books.lyricsHash;
              } else if (item.type === 'kalyansKalpataru' && item.kalyansKalpataru) {
                img = item.kalyansKalpataru.thumbPath || item.kalyansKalpataru.coverImage || item.kalyansKalpataru.image || null;
                title = item.kalyansKalpataru.name;
                subtitle = item.kalyansKalpataru.engName || '';
                typeLabel = t('Kalyan_Kalpataru_tr');
                lyricsHash = item.kalyansKalpataru.lyricsHash;
              } else if (item.type === 'monthlyMagazine' && item.monthlyMagazine) {
                img = item.monthlyMagazine.thumbPath || item.monthlyMagazine.coverImage || item.monthlyMagazine.image || null;
                title = item.monthlyMagazine.name;
                subtitle = item.monthlyMagazine.engName || '';
                typeLabel = t('magazine_tr');
                lyricsHash = item.monthlyMagazine.lyricsHash;
              } else if (item.type === 'vivekvanis' && item.vivekVanis) {
                img = item.vivekVanis.thumbPath || item.vivekVanis.coverImage || item.vivekVanis.image || null;
                title = item.vivekVanis.name;
                // subtitle = item.vivekvanis.engName || '';
                typeLabel = t('vivek_vani_tr');
                lyricsHash = item.vivekVanis.lyricsHash;
              } else if (item.type === 'videos' && item.videos) {
                img = item.videos.thumbPath || item.videos.coverImage || item.videos.image || null;
                title = item.videos.name;
                subtitle = item.videos.engName || '';
                typeLabel = t('Video_tr');
                lyricsHash = item.videos.lyricsHash;
              } else {
                title = item.type;
                subtitle = t('Unknown_type');
                lyricsHash = item.lyricsHash;
              }
              let lyricIconSrc = (lyricsHash && lyricsHash !== '' && lyricsHash !== 'null' && lyricsHash !== null && lyricsHash !== undefined)
                ? withLyric
                : withoutLyric;
              // For audios, pravachans, dailySatsang: show lyric icon as main image, for others show their image
              const isLyricType =
                item.type === 'audios' ||
                item.type === 'pravachans' ||
                item.type === 'dailySatsang';
              return (
                <Box key={index} sx={{ width: '23.5%', background: '#fff', boxShadow: '0 2px 6px rgba(0,0,0,0.1)', p: 1, mb: 1.2, display: 'flex', flexDirection: 'column', alignItems: 'center', cursor: 'pointer', minHeight: 140, position: 'relative' }}>
                  <Box sx={{ width: '80%', mb: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {isLyricType ? (
                      <img src={lyricIconSrc} alt="lyric icon" style={{ width: 48, height: 48, objectFit: 'contain', background: '#fff' }} />
                    ) : (
                      <img
                        src={img ? img : defaultImg}
                        alt={title}
                        style={{ width: '100%', height: 'auto', objectFit: 'cover', borderRadius: 0 }}
                      />
                    )}
                  </Box>
                  <Typography sx={{ fontWeight: 600, textAlign: 'center', maxWidth: '100%', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: '11px', lineHeight: 1.1, mt: 0.2, mb: 0.2 }}>{title}</Typography>
                  {/* {subtitle && <Typography variant="caption" sx={{ color: '#888', textAlign: 'center', maxWidth: '100%', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: '9px', lineHeight: 1 }}>{subtitle}</Typography>} */}
                  <Typography variant="caption" sx={{ color: '#f97316', fontWeight: 500, fontSize: '9px', lineHeight: 1, mt: 0.2 }}>{typeLabel}</Typography>
                </Box>
              );
            })}
          </Box>
        ) : (
          <Typography variant="body1" sx={{ textAlign: 'center', color: '#888' }}>
            {t('No_recent_views')}
          </Typography>
        )}
      </Box>
      {/* Footer */}
      {/* <FixedBottomBar /> */}
    </Box>
  );
};

export default MobileRecentlyViewed;